import React from 'react'
import { DomainNotificationBuilderView } from '../../components/notification-builder/views/domain-notification-builder-view'

export const MobileEditNotification = () => {
    return (
        <DomainNotificationBuilderView
            isMobile={true}
            formMode="edit"
            hideEstimatedReach={true}
            hidePreview={true}
            hideVariantManager={true}
            hideTestConfig={true}
            hidePushlyAiToggle={true}
        />
    )
}
